'use client';

import React, { useEffect, useState } from 'react';
import Image from 'next/image';

interface FixedCTABarProps {
  onBookClick: () => void;
}

const FixedCTABar: React.FC<FixedCTABarProps> = ({ onBookClick }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > window.innerHeight * 0.6);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div
      className={`fixed-cta-bar fixed bottom-0 left-0 right-0 z-50 ${visible ? 'visible' : ''}`}
    >
      <div className="glass-dark border-t border-clay/20 px-6 py-4">
        <div className="max-w-7xl mx-auto flex items-center justify-between gap-4">
          {/* Left — brand hint */}
          <div className="hidden sm:flex items-center gap-3">
            <div className="w-8 h-8 rounded-full flex items-center justify-center">
              <Image
                  src="/assets/logo.png"
                  alt="CorsAsia Logo"
                  width={80}
                  height={61}
                  className="h-8 w-auto object-contain"
                />
            </div>
            <div>
              <p className="font-serif italic text-parchment text-sm leading-none">CorsAsia</p>
              <p className="font-sans text-parchment/40 text-xs">Restaurant buffet à volonté en Corse</p>
            </div>
          </div>

          {/* Right — CTAs */}
          <div className="flex items-center gap-4 ml-auto">
            <a
              href="#menu"
              className="font-sans text-parchment/50 text-xs uppercase tracking-widest border-b border-parchment/20 pb-0.5 hover:text-parchment hover:border-parchment/50 transition-all"
            >
              Voir la carte
            </a>
            <button
              onClick={onBookClick}
              className="bg-corsasia text-parchment px-8 py-3 rounded-full font-sans font-semibold text-xs uppercase tracking-widest hover:bg-corsasia-dark transition-all duration-300 shadow-lg shadow-corsasia/30"
            >
              Réserver
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FixedCTABar;